<template>
  <div class="component-name">
    <span
      class="tw-opacity-50 tw-cursor-pointer"
      @click="() => show = true"
    >
      {{ displayName }}
      <i class="fa fa-lock tw-px-1" />
    </span>

    <b-modal
      v-model="show"
      width="650px"
    >
      <div class="card">
        <div class="card-content">
          <p class="tw-whitespace-normal">
            This feature is not currently enabled on your account, but we are excited to show it to you! Please schedule a demo or just let us know that you are interested.
          </p>
        </div>

        <footer class="card-footer">
          <div
            class="card-footer-item hover:tw-bg-blue-200"
            @click="notify"
          >
            <span class="tw-font-bold">Let us know!</span>
            <span class="tw-text-sm">Sends us an email</span>
          </div>

          <a
            class="card-footer-item tw-bg-blue-500 hover:tw-bg-blue-600 tw-text-white hover:tw-text-white"
            href="https://meetings.hubspot.com/robyn-wood/yourstake-demo-round-robin?__hstc=16697961.8d020c0cf948832d22679c1a3ecea739.1682447465898.1682447465898.1682447465898.1&__hssc=16697961.2.1682447465898&__hsfp=3850287098"
            target="_blank"
            rel="noreferrer noopener"
          >
            <span class="tw-font-bold">Schedule a demo</span>
            <span class="tw-text-sm">Takes you to HubSpot meeting scheduler</span>
          </a>
        </footer>
      </div>
    </b-modal>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'
import { postSendUpdateEmail } from '@frontend/api/emailsApi.js';

export default {
  name: 'ComponentName',
  components: { /* Subcomponents */ },
  props: ['displayName', 'featureName'],
  data() {
    return { show: false };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    notify() {
      postSendUpdateEmail(this.featureName);
      this.show = false;
    },
  },
};
</script>


<style scoped>
  .card-footer-item {
    display: flex;
    flex-direction: column;
    cursor: pointer;
  }
</style>
